import { sharedColors } from "ui/theme/colors"

const colors = {
  ...sharedColors,
  propBlue: "white",
  heroBackgroundEn: "#25296D",
  heroBackgroundHe: "#25296D",
  heroTextColor: "white",
  heroSvgIconColor: "#fff",
  filterModalHeaderColor: "rgba(255, 222, 0, 0.05)",
  filterModalHeaderTextColor: "#000",
  footerColor: "#25296D",
  faqRootBackground: "rgba(247, 247, 247, 1)",
  faqRootInsideBackground: "rgba(247, 247, 247, 1)",
  faqRootInsideBackgroundHover: "rgba(247, 247, 247, 1)",
  faqRootInsideColorHover: "#000",
  faqBorderColor: "rgba(247, 247, 247, 1)",
  faqTextColor: "#000",
  faqIconColor: "#000",
  faqIconColorAlternative: "#000",
  faqBoxShadow: "none",
  navBackgroundColor: "rgba(37, 41, 109, 1)",
  navTextColor: "white",
  selectedNavTextColor: "white",
  selectedSubNavTextColor: "white",
  selectedMobileNavTextColor: "black",
  footerSocialsBackgroundColor: "#25296D",
  footerLogoLinkBackgroundColor: "white",
  numberGridBackgroundColorEn: "linear-gradient(90deg, #25296D 0%, #1B1E4F 100%)",
  numberGridBackgroundColorHe: "linear-gradient(90deg, #1B1E4F 0%, #25296D 100%)",
  numberGridBorderColor: "rgba(37, 41, 109, 1)",
  newNumberGridTextColor: "#25296D",
  accordionPanelBackgroundColor: "rgba(37, 41, 109, 0.4)",
  jobsQuoteGalleryBackgroundColor: "rgba(37, 41, 109, 1)",
  teamContainerBackgroundColor: "rgba(37, 41, 109, 1)",
  buttonHoverBackgroundColor: "#25296D",
  buttonActiveBackgroundColor: "#25296D",
  buttonHoverTextColor: "white",
  paginationBackgroundColor: "#25296D",
  paginationTextColor: "white",
  bulletsBackgoundColor: "#25296D",
}

export default colors
